import styled from "styled-components";

export const RegistrationAcceptPolicyStyled = styled.div`
    label {
        color: var(--color-label-secondary);
    }
    .form-check .form-check-input[type=checkbox].is-invalid {
        border-color: var(--color-label-negative);
    }
    .form-check-input.is-invalid~.form-check-label {
        color: var(--color-label-secondary);
    }
`;
